import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const OnboardingContext = createContext();

export function useOnboarding() {
  return useContext(OnboardingContext);
}

export function OnboardingProvider({ children }) {
  const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState(false);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();

  useEffect(() => {
    if (currentUser) {
      // Check if user has completed onboarding
      const onboardingStatus = localStorage.getItem(`onboarding_${currentUser.uid}`);
      setHasCompletedOnboarding(onboardingStatus === 'completed');
    }
    setLoading(false);
  }, [currentUser]);

  const completeOnboarding = () => {
    if (currentUser) {
      localStorage.setItem(`onboarding_${currentUser.uid}`, 'completed');
      setHasCompletedOnboarding(true);
    }
  };

  const resetOnboarding = () => {
    if (currentUser) {
      localStorage.removeItem(`onboarding_${currentUser.uid}`);
      setHasCompletedOnboarding(false);
    }
  };

  const value = {
    hasCompletedOnboarding,
    completeOnboarding,
    resetOnboarding,
    loading
  };

  return (
    <OnboardingContext.Provider value={value}>
      {children}
    </OnboardingContext.Provider>
  );
} 